import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import * as assayActions from "../../actions/assays";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

function createData(
  name,
  targetName,
  assayType,
  wetLabValidated,
  chemistry,
  fluorophores,
  commercializedId
) {
  return {
    name,
    targetName,
    assayType,
    wetLabValidated,
    chemistry,
    fluorophores,
    commercializedId,
  };
}

const rows = {
  cellTherapy: [
    createData(
      "CD-19 CAR-T Assay",
      "Axi-cel and Tisa-cel construct",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD88164642"
    ),
    createData(
      "CD-19 CAR-T Assay",
      "Axi-cel construct only",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD45718942"
    ),
  ],
  geneTherapy: [
    createData(
      "AAV ITR-2 (FAM)",
      "ITR-2 sequence",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD15274642"
    ),
    createData(
      "AAV ITR-2 (HEX)",
      "ITR-2 sequence",
      "Expert Design",
      "No",
      "Probe",
      "HEX",
      "dEXD23004642"
    ),
    createData(
      "CMV promoter (FAM)",
      "Cytomegalovirus promoter",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD96423937"
    ),
    createData(
      "CMV promoter (HEX)",
      "Cytomegalovirus promoter",
      "Expert Design",
      "No",
      "Probe",
      "HEX",
      "dEXD70693710"
    ),
    createData(
      "CMV promoter (Cy5.5)",
      "Cytomegalovirus promoter",
      "Expert Design",
      "No",
      "Probe",
      "Cy5.5",
      "dEXD30054188"
    ),
    createData(
      "CMV enhancer (FAM)",
      "Cytomegalovirus enhancer",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD44963483"
    ),
    createData(
      "CMV enhancer (HEX)",
      "Cytomegalovirus enhancer",
      "Expert Design",
      "No",
      "Probe",
      "HEX",
      "dEXD19233256"
    ),
    createData(
      "eGFP (FAM)",
      "Enhanced Green Fluorescent Protein",
      "Expert Design",
      "No",
      "Probe",
      "HEX",
      "dEXD45075072"
    ),
    createData(
      "eGFP (HEX)",
      "Enhanced Green Fluorescent Protein",
      "Expert Design",
      "No",
      "Probe",
      "HEX",
      "dEXD22434642"
    ),
    createData(
      "hGFP (FAM)",
      "Humanized Green Fluorescent Protein",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD72134642"
    ),
    createData(
      "hGFP (HEX)",
      "Humanized Green Fluorescent Protein",
      "Expert Design",
      "No",
      "Probe",
      "HEX",
      "dEXD96535526"
    ),
    createData(
      "SV40 poly A (FAM)",
      "Simian virus 40 poly Adenylation signal",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD19344845"
    ),
    createData(
      "SV40 poly A (HEX)",
      "Simian virus 40 poly Adenylation signal",
      "Expert Design",
      "No",
      "Probe",
      "HEX",
      "dEXD83614618"
    ),
    createData(
      "SV40 poly A (Cy5)",
      "Simian virus 40 poly Adenylation signal",
      "Expert Design",
      "No",
      "Probe",
      "Cy5",
      "dEXD55784415"
    ),
    createData(
      "BGH poly A (FAM)",
      "Bovine growth hormone poly A",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD57884391"
    ),
    createData(
      "BGH poly A (HEX)",
      "Bovine growth hormone poly A",
      "Expert Design",
      "No",
      "Probe",
      "HEX",
      "dEXD32154164"
    ),
    createData(
      "HGH poly A (FAM)",
      "Human growth hormone poly A",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD97544642"
    ),
    createData(
      "HGH poly A (HEX)",
      "Human growth hormone poly A",
      "Expert Design",
      "No",
      "Probe",
      "HEX",
      "dEXD71814415"
    ),
  ],
  infectiousDisease: [
    createData(
      "2019-nCoV CDC ddPCR Triplex Probe Assay",
      "N1, N2 and RP",
      "kit",
      "yes",
      "Probe",
      "FAM, HEX, FAM/HEX",
      "dEXD28563542"
    ),
    createData(
      "Influenza A/B Triplex Assay",
      "Influenza A, Influenza B, RPP30",
      "Expert Design",
      "No",
      "Probe",
      "FAM, HEX, FAM/HEX",
      "dEXD84844642"
    ),
    createData(
      "Zika NS5",
      "NC_012532.1",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD90907415"
    ),
    createData(
      "Ebola VP24",
      "Sierra Leone (G3683/KM034562.1/eboVir3)",
      "Expert Design",
      "No",
      "Probe",
      "FAM",
      "dEXD65177188"
    ),
  ],
};

const FeatueContentTableRow = ({ row, actions }) => {
  const [notmyAssay, toggleNotMyAssay] = React.useState(true);
  const AddToMyAssayButton = () =>
    notmyAssay === true ? (
      <button
        className="small rounded outline"
        //*Once sample data is avalilable*/
        onClick={() => {
          toggleNotMyAssay(false);
          actions.addToMyAssay(row.commercializedId);
        }}
      >
        Add to my Assays
      </button>
    ) : (
      <a href="/digital-assays/assay-design-history">Go to My Assays</a>
    );

  return (
    <TableRow key={row.commercializedId}>
      <TableCell>
        <Link to={`/digital-assays/assay-detail/${row.commercializedId}`}>
          {row.name}
        </Link>
      </TableCell>
      <TableCell>{row.targetName}</TableCell>
      <TableCell>{row.assayType}</TableCell>
      <TableCell>{row.wetLabValidated}</TableCell>
      <TableCell>{row.chemistry}</TableCell>
      <TableCell>{row.fluorophores}</TableCell>
      <TableCell>{row.commercializedId}</TableCell>
      <TableCell align="center" className="call-to-action">
        <AddToMyAssayButton />
      </TableCell>
    </TableRow>
  );
};

const FeaturedTable = (props) => {
  const classes = useStyles();

  const { type, actions } = props;

  return (
    <div className="assay-results">
      <Table className={classes.table} size="small" aria-label="">
        <TableHead>
          <TableRow>
            <TableCell>Assay Name</TableCell>
            <TableCell>Target Name</TableCell>
            <TableCell>Assay Type</TableCell>
            <TableCell>Wet Lab Validated</TableCell>
            <TableCell>Chemistry</TableCell>
            <TableCell>Probe Fluorophores</TableCell>
            <TableCell>ID</TableCell>
            <TableCell className="call-to-action"> </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows[type].map((row, key) => (
            <FeatueContentTableRow key={key} {...{ row }} {...{ actions }} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

const stateToProps = (state) => state;

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

export default withRouter(
  connect(stateToProps, dispatchToProps)(FeaturedTable)
);
